import auth from '@/authfile';
import { useUserDetailsStore } from '@/stores/useUserDetails';

export default defineNuxtRouteMiddleware(async (to, from) => {
  const config = useRuntimeConfig();
  const auth0 = await auth(
    config.public.AUTH0_DOMAIN,
    config.public.AUTH0_CLIENT_ID,
    config.public.REDIRECT_URL,
    config.public.AUTH0_AUDIENCE
  );

  const isAuthenticated = await auth0.isAuthenticated();

  if (!isAuthenticated) {
    const query = to?.query;
    if (query && query.code && query.state) {
      await auth0.handleRedirectCallback();
    } else {
      // cache the path so we can redirect after authenticating
      localStorage.setItem('cachedPath', JSON.stringify(to.fullPath));
      await auth0.loginWithRedirect();
      return abortNavigation('Login required');
    }
  }

  // get token and set in localstorage
  const token = await auth0.getTokenSilently();
  localStorage.setItem('access_token', token);

  /**
   * cachedPath will only be set on initial login
   * redirect to intended path and remove cached path
   */
  if (localStorage.getItem('cachedPath')) {
    const cachedPath = JSON.parse(localStorage.getItem('cachedPath'));
    localStorage.removeItem('cachedPath');
    return navigateTo(cachedPath);
  }

  /**
   * Fetch user details immediately after user is authenticated
   */
  const userDetailsStore = useUserDetailsStore();
  await userDetailsStore.getUserDetails();

  navigateTo(to.path);
});
